import { render, staticRenderFns } from "./nshop-order-item-state.vue?vue&type=template&id=71af7f08&scoped=true&"
import script from "./nshop-order-item-state.vue?vue&type=script&lang=js&"
export * from "./nshop-order-item-state.vue?vue&type=script&lang=js&"
import style0 from "./nshop-order-item-state.vue?vue&type=style&index=0&id=71af7f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71af7f08",
  null
  
)

export default component.exports